import { render, staticRenderFns } from "./Assessment-list-single.vue?vue&type=template&id=3cf7fd86"
import script from "./Assessment-list-single.vue?vue&type=script&lang=js"
export * from "./Assessment-list-single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports